import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=5e93bb9a&scoped=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=js"
export * from "./MessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=5e93bb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e93bb9a",
  null
  
)

export default component.exports